<app-topnav [pageName]="pageName"></app-topnav>

<div class="h-30"></div>
<div class="container" [hidden]="!hideReviewPanel">
  <div class="content" role="main">
    <div class="facility-heading">Create Tag</div>
    <form #rpform="ngForm">
      <div class="designatedFacilityForm">

        <div class="form-fields">
          <mat-form-field appearance="outline" floatLabel="always" >
            <mat-label>Tag Name</mat-label>
            <input matInput class="form-control-textbox" [(ngModel)]="createTag.tagName" name="name" required/>
          </mat-form-field>
          @if (isSubmitted && createTag.tagName == '') {
            <mat-error class="registration-validation-error">Tag Name is required</mat-error>
          }
        </div>


        <div class="form-fields">

          <mat-form-field>
            <mat-label>Select Category</mat-label>
            <mat-select placeholder="Select" name="tagCategories" multiple [(value)]="selectedCategory"
              (selectionChange)="onCategoryCheckboxChange()">
              <mat-select-trigger>
                <div class="selected-pills">
                  @for (cat of selectedCategory; track cat) {
                    <span class="pill" [hidden]="!(getCategoryNames(cat)!=='')">
                      <span>{{ getCategoryNames(cat).replace(',','') }}</span>
                    </span>
                  }
                </div>
              </mat-select-trigger>
              @for (tc of tagCategories; track tc) {
                <mat-option [value]="tc.id">
                  {{ tc.categoryName }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (isSubmitted && createTag.tagsCategoriesId.length == 0) {
            <mat-error class="registration-validation-error">Tag category is required</mat-error>
          }

        </div>
        <div class="h-30"></div>

        <div>
          Status
          <div class="toggle">
            <div class="switch-div">
              <input type="radio" name="sizeBy" value="active" id="active" class="active" [(ngModel)]="tagStatus" />
              <label for="active">Active</label>
            </div>
            <div class="switch-div">
              <input type="radio" name="sizeBy" value="inactive" id="inactive" class="inactive" [(ngModel)]="tagStatus"/>
              <label for="inactive">Inactive</label>
            </div>
          </div>
        </div>

        <div class="mb-10"></div>


        <div class="form-buttons">
          <button class="submit-form-button" (click)="addTag(rpform)">Save</button>
          <a routerLink="/tags-list" class="submit-form-button cancel-button"
            >Cancel</a
            >
          </div>

        </div>
      </form>
    </div>
  </div>

  <!--review section of add tag-->
  <app-footer [bbapp]="true"></app-footer>
